/* eslint-disable */
import Vue from 'vue'

export default Vue.directive('google-identity-login-btn', {
  inserted: function (el, binding, vnode) {
    function InitGoogleButton () {
      google.accounts.id.initialize({
        client_id: clientId,
        callback: OnSuccess
      });

      google.accounts.id.renderButton(el, googleBtnConfigs);
    }

    function OnSuccess (resp) {
      vnode.context.onGoogleAuthSuccess(resp.credential);
    }

    function checkComponentMethods () {
      if(!el.id)
        throw new Error('The google sign in container requires an "id" attribute');

      if (!vnode.context.onGoogleAuthSuccess)
        throw new Error('The method onGoogleAuthSuccess must be defined on the component')
    }

    checkComponentMethods()

    let clientId = binding.value.clientId;

    const googleBtnConfigs = {
      type: binding.value.type || "standard",
      shape: binding.value.shape || "rectangular",
      theme: binding.value.theme || "filled_blue",
      text: binding.value.text || "continue_with",
      size: binding.value.size || "large",
      locale: binding.value.locale || "es-419",
      logo_alignment: binding.value.logo_alignment || "center",
      width: binding.value.width || 200
    };

    let googleSignInAPI = document.getElementById('google-gsi-client')
    if (!googleSignInAPI) {
      googleSignInAPI = document.createElement('script')
      googleSignInAPI.id = 'google-gsi-client'
      googleSignInAPI.async = true
      googleSignInAPI.setAttribute('src', 'https://accounts.google.com/gsi/client')
      document.head.appendChild(googleSignInAPI)
    }
    if (window.google && window.google.accounts) {
      InitGoogleButton()
    } else {
      googleSignInAPI.addEventListener('load', InitGoogleButton, { once: true })
    }
  }
});
